import type { bankingApiSpec } from "@wingspanhq/wingspan-api-types";
import { statementsService } from "./statementsService";
import { IStatementsRequestQuery } from "./types";

type IStatementListResponse =
  bankingApiSpec.operations["listInternalAccountStatements"]["responses"]["200"]["content"]["application/json"];

export const getStatements = async (
  query?: IStatementsRequestQuery
): Promise<IStatementListResponse> => {
  const { data } = await statementsService.get("/internal-account-statements", {
    params: query
  });

  return data;
};
